import { UserPrivacy } from "../../../constants";
import { PrivacyNavListData, PrivacyPolicyData } from "../../../data/pages/Other";
import { routes } from "../../../routers/routes";
import Breadcrumbs from "../../commonComponents/breadcrumbs";
import Scrollspy from "./common/scrollspy";

const PrivacyContainer = () => {
  return (
    <>
      <Breadcrumbs title="Privacy" url={routes.Home.CarDemo1} mainClass="page-breadcrumbs-section" />
      <Scrollspy title={UserPrivacy} list={PrivacyNavListData} content={PrivacyPolicyData} />
    </>
  );
};

export default PrivacyContainer;
